"use client"
import {
  useIsClient
} from "./chunk-XMHMZEKB.js";

// src/ClientOnly.tsx
import { Fragment, jsx } from "react/jsx-runtime";
var ClientOnly = ({ children, fallback }) => /* @__PURE__ */ jsx(Fragment, { children: useIsClient() ? children : fallback });

export {
  ClientOnly
};
//# sourceMappingURL=chunk-LFQ3IFLO.js.map